"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateSubsystems = void 0;
const options_1 = __importDefault(require("../../data/options"));
const generate_subsystem_1 = require("./generate-subsystem");
const utils_1 = require("../../utils");
const generateSubsystems = (contactRefId, subsystemOptions) => {
    const { desiredSubsystems } = subsystemOptions || {};
    if (desiredSubsystems) {
        return desiredSubsystems.map((subSystemString) => (0, generate_subsystem_1.generateSubsystem)(contactRefId, subSystemString, subsystemOptions));
    }
    else {
        //generate random subsystems
        const subsystemName = (0, utils_1.shuffle)(options_1.default.subsystems);
        const subsystemArray = Array.from({ length: options_1.default.subsystems.length }, () => (0, generate_subsystem_1.generateSubsystem)(contactRefId, subsystemName, subsystemOptions));
        return subsystemArray.filter((value, index, self) => self.findIndex((v) => v.name === value.name) === index);
    }
};
exports.generateSubsystems = generateSubsystems;
